'use client';

import * as d3 from 'd3';
import React from 'react';

import { Resolution } from '@blockscout/stats-types';

import { STATS_RESOLUTIONS } from 'src/components/stats/constants';
import { resolveToken } from 'src/hooks/useChartColors';

import ChartTooltipRow from './ChartTooltipRow';

const ChartTooltipTitle = ({ resolution = Resolution.DAY }: { resolution?: Resolution }) => {
  const titleColor = resolveToken('yellow.300');
  const resolutionTitle = STATS_RESOLUTIONS.find(r => r.id === resolution)?.title || 'day';

  return (
    <ChartTooltipRow lineNum={ 0 }>
      <text
        className="ChartTooltip__title"
        transform="translate(0,0)"
        fill={ titleColor }
        opacity={ 0 }
        dominantBaseline="hanging"
      >
        { `Incomplete ${ resolutionTitle.toLowerCase() }` }
      </text>
    </ChartTooltipRow>
  );
};

export default React.memo(ChartTooltipTitle);

export function useRenderTitle(ref: React.RefObject<SVGGElement>) {
  return React.useCallback((isVisible: boolean) => {
    d3.select(ref.current)
      .select('.ChartTooltip__title')
      .attr('opacity', isVisible ? 1 : 0);
  }, [ ref ]);
}
